import styled from "styled-components";

export const InputWrapper = styled.div`
  width: 72%;
  margin: 20px auto;
  margin-top: 0;

  display: flex;
  flex-direction: column;
  justify-content: start;

  gap: 3px;
`;

export const InputHelper = styled.span`
  font-size: medium;
`;
